<template>
  <b-container>
    <div v-if="!loading && competition" class="text-left">
      <div class="d-block d-lg-flex justify-content-between mt-5 ">
        <h2 class="name">{{ competition.name }}</h2>
        <div class="d-flex align-items-center">
          <font-awesome-icon
            :icon="
              `${
                this.fastFavouriteColorChange === true
                  ? 'fa-solid fa-bookmark'
                  : this.fastFavouriteColorChange === false
                  ? 'fa-regular fa-bookmark'
                  : competitionIsFavourite
                  ? 'fa-solid fa-bookmark'
                  : 'fa-regular fa-bookmark'
              }`
            "
            class="icon"
            @click="toggleFavorites(competition._id)"
          />
          <b-button variant="primary" class="ml-3 interested-btn" @click="handleOfferLink(competition.link)"
            >Érdekel</b-button
          >
        </div>
      </div>
      <div class="mt-5 mb-4">
        <FundMapCompanyInfo />
      </div>
      <p class="application-type my-3">{{ getAppType() }}</p>
      <p class="description mb-4">{{ competition.text }}</p>
      <p v-if="relatedDefinitions.length > 0" class="related-definitions">
        <b>Kapcsolódó fogalmak:</b>
        <b-button
          class="related-defs-btn"
          variant="secondary"
          @click="handleRelDefBtn(r.slug)"
          v-for="r in relatedDefinitions"
          :key="r.slug"
        >
          {{ r.name }}
        </b-button>
      </p>
      <div v-if="competition.type === 'APPLICATION'" class="details-container">
        <ApplicationDetails :competition="competition" />
      </div>
      <div v-if="competition.type === 'CREDIT'" class="details-container">
        <CreditDetails :competition="competition" />
      </div>
      <div v-if="competition.type === 'CAPITAL_PRODUCT'" class="details-container">
        <CapitalProductDetails :competition="competition" />
      </div>
      <div v-if="competition.type === 'COMBINED'" class="details-container">
        <CombinedDetails :competition="competition" />
      </div>
      <h2 class="title-secondary">Forrás igénybevételének feltételei</h2>

      <!-- the commented component works with all the data backend sends, until the flow is clarified, a simplier solution is implemented below -->
      <!-- <div class="bubble-wrapper">
        <div class="d-none d-md-flex mb-3">
          <div class="col">
            <h5>Ellenőrzött adat</h5>
          </div>
          <div class="col">
            <h5>Feltétel</h5>
          </div>
          <div class="col">
            <h5>Kalkulációhoz használt adatok</h5>
          </div>
        </div>
        <div v-for="row in matchingResults" :key="row.title + '-mobile'" class="d-none d-md-flex mb-1">
          <p class="col requirement-title">{{ row.title }}</p>
          <strong class="col bold-text break-text ">{{ formatCondition(row.title, row.requirement) }} </strong>

          <div :class="[row.passed ? 'success-filter' : 'fail-filter', 'col d-flex align-items-center bold-text']">
            <font-awesome-icon :icon="`${row.passed ? 'fa-solid fa-check' : 'fa-solid fa-xmark'}`" />
            <p class="m-0 ml-2">
              {{ formatCompanyData(row.title, row.companyData) }}
            </p>
          </div>
        </div>

        <div class="d-block d-md-none py-4 req-section" v-for="row in matchingResults" :key="row.title">
          <h6>{{ row.title }}</h6>
          <div class="d-flex align-items-center justify-content-between break-text">
            <p class="m-0">Feltétel</p>
            <strong class="col bold-text break-text text-right "
              >{{ formatCondition(row.title, row.requirement) }}
            </strong>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0">Kalkulációhoz használt adatok</p>
            <div :class="[row.passed ? 'success-filter' : 'fail-filter', 'd-flex align-items-center bold-text']">
              <font-awesome-icon :icon="`${row.passed ? 'fa-solid fa-check' : 'fa-solid fa-xmark'}`" />
              <p class="m-0 ml-2">
                {{ formatCompanyData(row.title, row.companyData) }}
              </p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="bubble-wrapper" v-b-toggle="'collapse-req-data'">
        <div @click="toggleOpen" style="padding:36px;">
          <b-row>
            <div class="col ml-3">
              <h5>Ellenőrzött adat</h5>
            </div>
            <font-awesome-icon
              icon="fa-solid fa-chevron-right"
              :class="`chevron ${chevronIsOpen ? 'rotated' : ''} chevron-default mr-5`"
            />
          </b-row>
          <b-collapse v-bind:id="'collapse-req-data'">
            <div class=" d-md-flex mb-3">
              <div class="col"></div>
            </div>
            <div v-for="title in this.requirementFiltersResult" :key="title" class="d-flex mb-1">
              <p class="col-10 requirement-title">{{ title }}</p>

              <div :class="['success-filter', 'col d-flex align-items-center bold-text']">
                <font-awesome-icon icon="fa-solid fa-check" />
              </div>
            </div>
          </b-collapse>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <b-button class="interested-btn" @click="goBack">Vissza</b-button>
        <b-button variant="primary" class="ml-3 interested-btn" @click="handleOfferLink(competition.link)"
          >Érdekel</b-button
        >
      </div>
    </div>
  </b-container>
</template>

<script>
import { getCompetitionWithDetails } from '../../api/competition'
import { mapGetters } from 'vuex'
import { getReadableCompetitionType } from '../../constants/competitionTypes'
import FundMapCompanyInfo from '../../components/FundMapCompanyInfo.vue'
import { getMatchingResultForCompetition } from '../../api/fundMap'
import ApplicationDetails from './components/DetailsTables/ApplicationDetails'
import CreditDetails from './components/DetailsTables/CreditDetails.vue'
import CapitalProductDetails from './components/DetailsTables/CapitalProductDetails.vue'
import CombinedDetails from './components/DetailsTables/CombinedDetails.vue'
import { getRelatedDefinition } from '../../api/knowledgebase'
import * as ImaginaryUserCompanyApi from '../../api/imaginaryUserCompany'
import * as imaginaryCompanyApi from '../../api/imaginaryCompany'
import _ from 'lodash'

export default {
  data() {
    return {
      competition: null,
      relatedDefinitions: [],
      loading: true,
      matchingResults: null,
      selectedCompanyId: '',
      imaginaryUserCompanies: [],
      requirementFiltersResult: [],
      chevronIsOpen: false,
      fastFavouriteColorChange: null
    }
  },
  components: { FundMapCompanyInfo, ApplicationDetails, CreditDetails, CapitalProductDetails, CombinedDetails },
  computed: {
    ...mapGetters(['userCompanies', 'fundMapCompany', 'fundMapCompanyAttributes', 'getUser']),
    competitionIsFavourite() {
      if (!this.competition) {
        return false
      }

      let companyFound
      if (this.selectedCompanyId.toString().length > 8) {
        companyFound = this.imaginaryUserCompanies.find(
          company => company.imaginaryCompanyId === this.selectedCompanyId
        )
      } else {
        companyFound = this.userCompanies.find(company => company.companyId === this.selectedCompanyId)
      }

      if (!companyFound) {
        return false
      }

      return companyFound.favoriteCompetitionIds.includes(this.competition._id)
    },
    userCompany() {
      return this.userCompanies.find(company => company.companyId === this.selectedCompanyId)
    },
    imaginaryUserCompany() {
      return this.imaginaryUserCompanies.find(company => company.imaginaryCompanyId === this.selectedCompanyId)
    }
  },

  methods: {
    toggleOpen() {
      this.chevronIsOpen = !this.chevronIsOpen
    },
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    formatCompanyData(title, data) {
      if (typeof data === 'object' && data.length > 0) {
        const result = data.map(row => {
          return row
        })
        let res = ''
        result.forEach(x => {
          res += ', ' + x
        })

        return res.slice(1)
      }

      if (typeof data === 'boolean' || title === 'A vállalkozás pozitív saját tőkével rendelkezik') {
        return ' '
      }

      if (title === 'Mérlegfőösszeg' || title === 'Árbevétel' || title === 'Exportértékesítés nettó árbevétele') {
        return this.numberWithDots(data) + ' HUF'
      }

      if (title === 'Minimum lezárt üzleti évek száma') {
        return this.numberWithDots(data) + ' év'
      }

      if (title === 'Az exportértékesítés nettó árbevétele a teljes árbevételhez képest (%)') {
        return data.toFixed(2) + ' %'
      }

      if (title === 'Létszám') {
        return this.numberWithDots(data) + ' fő'
      }
      return data
    },
    formatCondition(title, data) {
      if (title === 'Mérlegfőösszeg' || title === 'Árbevétel' || title === 'Exportértékesítés nettó árbevétele') {
        return this.numberWithDots(data) + ' HUF'
      }

      if (title === 'Minimum lezárt üzleti évek száma') {
        return this.numberWithDots(data) + ' év'
      }

      if (title === 'Az exportértékesítés nettó árbevétele a teljes árbevételhez képest (%)') {
        return this.numberWithDots(data) + ' %'
      }

      if (title === 'Létszám') {
        return this.numberWithDots(data) + ' fő'
      }
      if (title === 'Irányítószám') {
        return data
      }

      if (title === 'Kizáró pályázatok száma') {
        return 'Cége nem igényelt kizáró pályázatot.'
      }
      return this.numberWithDots(data)
    },
    handleOfferLink(link) {
      const win = window.open(link, '_blank')
      win.focus()
    },
    handleRelDefBtn(slug) {
      this.$router.push(`/knowledgebase/${slug}`, () => {})
    },
    async toggleFavorites(competitionId) {
      if (this.competitionIsFavourite) {
        this.fastFavouriteColorChange = false
      } else {
        this.fastFavouriteColorChange = true
      }
      let favoriteCompetitionIds = []

      if (this.competitionIsFavourite) {
        if (this.selectedCompanyId.toString().length > 8) {
          favoriteCompetitionIds = this.imaginaryUserCompany.favoriteCompetitionIds.filter(
            favoriteCompetitionId => favoriteCompetitionId !== competitionId
          )
        } else {
          favoriteCompetitionIds = this.userCompany.favoriteCompetitionIds.filter(
            favoriteCompetitionId => favoriteCompetitionId !== competitionId
          )
        }
      } else {
        if (this.selectedCompanyId.toString().length > 8) {
          favoriteCompetitionIds = [...this.imaginaryUserCompany.favoriteCompetitionIds, competitionId]
        } else {
          favoriteCompetitionIds = [...this.userCompany.favoriteCompetitionIds, competitionId]
        }
      }

      if (this.fundMapCompany.imaginaryCompany) {
        await imaginaryCompanyApi.patchImaginaryUserCompanyById(this.imaginaryUserCompany._id, favoriteCompetitionIds)

        this.getImaginaryUserCompaniesByCompanyId(this.selectedCompanyId)
      } else {
        await this.$store.dispatch('patchUserCompany', {
          userCompanyId: this.userCompany.id,
          favoriteCompetitionIds
        })
        this.$store.dispatch('getUserCompanies', {})
      }
    },
    getAppType() {
      return getReadableCompetitionType(this.competition.type)
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    goBack() {
      this.$router.back()
    },
    async getImaginaryUserCompaniesByCompanyId(companyId) {
      try {
        this.imaginaryUserCompanies = await ImaginaryUserCompanyApi.getImaginaryUserCompanyById(companyId)
      } catch (e) {
        console.log(e)
      }
    }
  },
  async created() {
    const id = this.$route.params.id

    if (!id) {
      return this.$router.push('/fund-map')
    }
    if (!this.fundMapCompany) {
      return this.$router.push('/fund-map')
    }

    if (this.fundMapCompany.imaginaryCompany) {
      this.selectedCompanyId = this.fundMapCompany.imaginaryCompany.companyId
      this.getImaginaryUserCompaniesByCompanyId(this.selectedCompanyId)
    } else {
      this.selectedCompanyId = this.fundMapCompany.flaggerId
    }

    try {
      this.$store.dispatch('getUserCompanies', {})
    } catch (e) {
      console.log('Could not load userCompanies')
    }

    try {
      const response = await getCompetitionWithDetails(id)
      this.competition = response

      if (
        this.competition.fundId.productData.relatedDefinitions &&
        this.competition.fundId.productData.relatedDefinitions.length > 0
      ) {
        let relatedDefinitionsP = []
        for (let d of this.competition.fundId.productData.relatedDefinitions) {
          relatedDefinitionsP.push(getRelatedDefinition(d))
        }
        let relatedDefinitionsQ = await Promise.allSettled(relatedDefinitionsP)
        this.relatedDefinitionsQ = relatedDefinitionsQ.filter(e => e.status === 'fulfilled')
        this.relatedDefinitions = relatedDefinitionsQ.map(e => e.value)
      }
    } catch (e) {
      console.log('Fetching competition failed with cause:', e)
    }

    try {
      let isImaginaryCompany = false
      let searchParamsToSend = {}

      if (!this.fundMapCompany.imaginaryCompany) {
        isImaginaryCompany = false
      } else {
        isImaginaryCompany = true
      }
      if (isImaginaryCompany) {
        searchParamsToSend = {
          teaor: this.fundMapCompanyAttributes.teaor || this.fundMapCompany.imaginaryCompany.mainTeaor,
          zip: this.fundMapCompanyAttributes.zip || this.fundMapCompany.imaginaryCompany.address,
          revenue: this.fundMapCompany.imaginaryCompany.income,
          balanceSheetTotal: this.fundMapCompany.imaginaryCompany.balanceSheetTotal,
          latestExportRevenue: this.fundMapCompany.imaginaryCompany.latestExportRevenue,
          head_count: this.fundMapCompany.imaginaryCompany.headCount,
          isSupplier: this.fundMapCompanyAttributes.isSupplier,
          statisticalGFO: this.fundMapCompany.imaginaryCompany.form,
          revenueFromAggriculture: this.fundMapCompanyAttributes.revenueFromAggriculture
        }
      } else {
        searchParamsToSend = { ...this.fundMapCompanyAttributes }
        // 'address' is necessary due to data reload on step 1, but we should not send it to BE
        if (this.fundMapCompanyAttributes.address) {
          delete searchParamsToSend['address']
        }
      }
      const companyId = this.fundMapCompany.flaggerId
        ? this.fundMapCompany.flaggerId
        : this.fundMapCompany.imaginaryCompany.companyId
      this.matchingResults = await getMatchingResultForCompetition(this.competition._id, companyId, searchParamsToSend)

      const titles = []
      this.matchingResults.forEach(x => {
        titles.push(x.title)
      })
      this.requirementFiltersResult = _.uniq(titles)
    } catch (e) {
      console.log('Get matching results failed!')
      return this.$router.push('/fund-map')
    } finally {
      this.loading = false
    }
  },
  mounted() {
    window.onbeforeunload = function(e) {
      e.returnValue = ''
      return ''
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null
  }
}
</script>

<style scoped>
.name {
  font-weight: 800;
  font-size: 36px;
  max-width: 800px;
}

.icon {
  color: #ba3b46;
  cursor: pointer;
  font-size: 20px;
}

.application-type {
  padding: 4px 8px;
  border-radius: 100px;
  font-weight: 500;
  font-size: 12px;
  color: #000;
  background-color: #dfe6e9;
  width: max-content;
}

.description {
  font-weight: 400;
  font-size: 18px;
  max-width: 800px;
}

.interested-btn {
  width: max-content;
}

.related-defs-btn {
  font-size: 75%;
  margin: 5px;
  padding: 5px;
  height: auto;
}

.details-container {
  margin-bottom: 32px;
}
.details-container p {
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
}

.title-secondary {
  margin-bottom: 32px;
  font-weight: 700;
  font-size: 24px;
}

.bubble-wrapper {
  margin-bottom: 24px;
  background-color: #f7fbfc;
  border-radius: 8px;
}

.success-filter {
  color: #00903c;
}
.fail-filter {
  color: #ba3b46;
}

.bold-text {
  font-weight: 700;
  font-size: 16px;
}

.break-text {
  word-wrap: break-word !important;
}

.requirement-title {
  font-weight: 400;
  font-size: 16px;
}

.req-section {
  border-bottom: 1px solid #b2bec3;
}

@media only screen and (max-width: 768px) {
  .bubble-wrapper {
    padding-inline: 16px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1200px) {
  .name {
    font-weight: 800;
    font-size: 48px;
  }
}
@media only screen and (min-width: 1200px) {
  .description {
    font-size: 20px;
  }

  .title-secondary {
    font-size: 32px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1440px) {
  .name {
    font-weight: 800;
    font-size: 56px;
  }
}
@media only screen and (min-width: 1440px) {
  .name {
    font-weight: 800;
    font-size: 64px;
  }
}

.toggle-text {
  cursor: pointer;
  font-size: 20px;
}

.chevron-default {
  position: relative;
  right: 0;
  color: #636e72;
  font-size: 24px;
}

.chevron {
  transition: all 0.3s;
}

.chevron.rotated {
  transform: rotate(90deg);
}
</style>
